import React from 'react';
import { PortfolioShowcase } from '../components/sections';

export const PortfolioPage: React.FC<{ onOpenConsultation: () => void }> = ({ onOpenConsultation }) => {
  return (
    <div className="pt-20">
      <PortfolioShowcase onOpenConsultation={onOpenConsultation} />
    </div>
  );
};
